const multiplierPositive = (number: string, decimals: number) => `${number}E+${decimals}`;
const multiplierNegative = (number: string, decimals: number) => `${number}E-${decimals}`;

const getExponentialParts = (number: number | string[]) =>
    Array.isArray(number) ? number : String(number).split(/[eE]/);

const isExponential = (number: number | string[]) => {
    const eParts = getExponentialParts(number);

    return !Number.isNaN(Number(eParts[1]));
};

export const fromExponential = (number: number) => {
    const eParts = getExponentialParts(number);

    if (!isExponential(eParts)) {
        return eParts[0];
    }

    const sign = eParts[0][0] === "-" ? "-" : "";
    const digits = eParts[0].replace(/^-/, "");
    const digitsParts = digits.split(".");
    const wholeDigits = digitsParts[0];
    const fractionDigits = digitsParts[1] || "";
    let e = Number(eParts[1]);

    if (e === 0) {
        return `${sign + wholeDigits}.${fractionDigits}`;
    } else if (e < 0) {
        const countWholeAfterTransform = wholeDigits.length + e;

        if (countWholeAfterTransform > 0) {
            const wholeDigitsAfterTransform = wholeDigits.substr(0, countWholeAfterTransform);
            const wholeDigitsTransformedToFracton = wholeDigits.substr(countWholeAfterTransform);

            return `${sign + wholeDigitsAfterTransform}.${wholeDigitsTransformedToFracton}${fractionDigits}`;
        }

        let zeros = "0.";
        e += 1;

        while (e) {
            zeros += "0";
            e += 1;
        }

        return sign + zeros + wholeDigits + fractionDigits;
    }
    const countFractionAfterTransform = fractionDigits.length - e;

    if (countFractionAfterTransform > 0) {
        const fractionDigitsAfterTransform = fractionDigits.substr(e);
        const fractionDigitsTransformedToWhole = fractionDigits.substr(0, e);

        return `${sign + wholeDigits + fractionDigitsTransformedToWhole}.${fractionDigitsAfterTransform}`;
    }

    let zerosCount = -countFractionAfterTransform;
    let zeros = "";

    while (zerosCount) {
        zeros += "0";
        zerosCount -= 1;
    }

    return sign + wholeDigits + fractionDigits + zeros;
};

export const round = (number: number, decimals: number = 0) => {
    if (isNaN(number)) {
        return 0;
    }

    const decimal = fromExponential(number);
    const value = multiplierPositive(decimal, decimals);

    const round = Math.round(parseFloat(value));

    return Number(multiplierNegative(fromExponential(round), decimals));
};

export const isNegative = (number: number) => Math.sign(number) === -1;

export const isNumberOutOfRange = (number: number) =>
    number > Number.MAX_SAFE_INTEGER || number < Number.MIN_SAFE_INTEGER;
